import { useEffect, useState } from "react";
import "../styles/App.css";
import AtomicAppBar from "../components/molecules/AppBar";
import {
  Base_APPLICATION_URL,
  Base_HUBSPOT_FORM_ID,
  Base_HUBSPOT_PORTAL_ID,
} from "../config/config";

declare global {
  interface Window {
    hbspt: {
      forms: {
        create(config: object): void;
      };
    };
  }
}
const HubspotForm = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  useEffect(() => {
    if (!scriptLoaded) {
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/v2.js";
      document.body.appendChild(script);

      script.addEventListener("load", () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: `${Base_HUBSPOT_PORTAL_ID}`,
            formId: `${Base_HUBSPOT_FORM_ID}`,
            target: "#hubspotForm",
            onFormSubmit: (form: any) => {
              localStorage.setItem("userEmail", form.email.value);
              localStorage.removeItem("updatedDimensions");

              window.location.href = `${Base_APPLICATION_URL}HomePage?email=${form.email.value}`;
            },
          });
          setScriptLoaded(true); // Set the flag to true to prevent reloading.
        }
      });
    }
  }, [scriptLoaded]);

  return (
    <div>
      <AtomicAppBar></AtomicAppBar>
      <div id="hubspotForm" className="hubspot-form"></div>
    </div>
  );
};

export default HubspotForm;
